import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button } from 'shared/mui/Buttons';
import { Typography } from 'shared/mui/Typography';

import { WrapperStyled } from './CommissionsTabsTaskCreate.styled';

type CommissionsTableTaskCreateProps = {
  onCreate: () => void;
};

export const CommissionsTabsTaskCreate: React.FC<CommissionsTableTaskCreateProps> = ({
  onCreate,
}) => {
  const translate = useTypedTranslate();

  return (
    <WrapperStyled>
      <Typography variant="body2">
        {translate('app.merchantsShowNotifications.createCommissionRecalculation')}
      </Typography>
      <Button
        color="primary"
        label={translate('app.buttons.create')}
        onClick={onCreate}
        variant="contained"
      />
    </WrapperStyled>
  );
};
